<template>
  <v-container class="mt-12 pt-8 serious" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12" md="4" ACCOUNTTOPINFOandSELECTOR>
            <v-row>
              <v-col cols="12" ACCOUNTTOPINFO>
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col cols="4" class="text-center">
                        <div class="mb-2">
                          <v-avatar size="30" v-if="user && user.name" color="primary white--text"
                            style="font-size:12px;">
                            {{user.name.slice(0,1)}}
                          </v-avatar>
                        </div>
                        <div>{{user.name}}</div>
                      </v-col>
                      <v-col cols="8" class="text-left">
                        <v-chip color="primary" :class="`${arabic?'arFont':'enFont'} white--text`">{{ i18n["new_account"] }}</v-chip>
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                      <v-col cols="6" :class="`${arabic?'arFont':'enFont'}`">
                        {{  i18n["affiliate_code"] }}
                      </v-col>
                      <v-col cols="6" v-if="user.account && user.account.affiliate_code">
                        {{user.account.affiliate_code}}
                      </v-col>
                      <v-col cols="12">
                        <v-btn color="secondary" disabled block small :class="`${arabic?'arFont':'enFont'}`">{{ i18n['copy_affiliate_link'] }}</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" ACCOUNTSELECTOR>
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" class="text-center">
                        <v-list>
                          <v-list-item-group v-model="selectedPanel">
                            <v-list-item v-for="(item, i) in subitems" :key="i" :value="item.value">
                              <v-list-item-icon>
                                <v-icon v-text="item.icon"></v-icon>
                              </v-list-item-icon>
                              <v-list-item-content @click="showPannel(item.value)"
                                :class="`${arabic?'arFont':'enFont'}`">
                                <v-list-item-title>{{ i18n[item.text] }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="8">
            <v-row>
              <v-col cols="12" PANNELS>
                <v-card v-if="firstPanel" firstPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">person</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`"> {{ i18n["personal_information"] }}</div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`"> {{  i18n["you_can_edit_your_personal_info_and_some_settings"] }}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="6" FIELD>
                            <v-text-field :label="i18n['name']" v-model="user.name" :class="`${arabic?'arFont':'enFont'}`"
                              outlined hide-details dense></v-text-field>
                          </v-col>
                          <v-col cols="6" FIELD>
                            <v-text-field :label="i18n['email']" v-model="user.email" :class="`${arabic?'arFont':'enFont'}`"
                              disabled readonly outlined hide-details dense></v-text-field>
                          </v-col>
                          <v-col cols="6" FIELD>
                            <v-text-field :label="i18n['phone_number']" v-model="user.phone" :class="`${arabic?'arFont':'enFont'}`"
                              outlined :disabled="user.verified_phone ? true : false" hide-details dense></v-text-field>
                          </v-col>
                          <v-col cols="12" FIELD>
                            <Verification @snackbarNotification="sendSnackbarNotification" />
                            <VerificationEmail @snackbarNotification="sendSnackbarNotification" />

                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" :class="`${arabic?'arFont':'enFont'}`" @click="UpdateMe(user)">{{ i18n["edit_information"] }}</v-btn>
                  </v-card-actions>
                </v-card>
                <v-card v-if="secondPanel" secondPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">password</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">{{  i18n["change_password"] }}</div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">{{ i18n['you_can_change_your_password_here'] }}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="6" FIELD>
                            <v-text-field :label="i18n['email']" v-model="user.email" :class="`${arabic?'arFont':'enFont'}`"
                              disabled readonly outlined hide-details dense></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" :class="`${arabic?'arFont':'enFont'}`" @click="resetPass()">{{ i18n["request_password_change_by_email"] }}</v-btn>
                  </v-card-actions>
                </v-card>
                <v-card v-if="thirdPanel" thirdPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">loyalty</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">{{ i18n["refered_account"] }}</div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">{{ i18n["your_referals"] }}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="6" FIELD>
                            <v-card color="grey lighten-2" class="text-center py-12" flat>
                              <div :class="`${arabic?'arFont':'enFont'} black--text`">{{ i18n['accounts_count'] }}</div>
                              <div style="font-size:40px;" class="mt-5">0</div>
                            </v-card>
                          </v-col>
                          <v-col cols="6" FIELD>
                            <v-card color="grey lighten-2" class="text-center py-12" flat>
                              <div :class="`${arabic?'arFont':'enFont'} black--text`">{{ i18n["orders_count"] }}</div>
                              <div style="font-size:40px;" class="mt-5">0</div>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-card v-if="fourthPanel" fourthPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">store</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">{{ i18n["business_account"] }}</div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">{{ i18n["business_account_info_and_settings"] }}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="12" style="direction:ltr !important;" class="text-left elevation-2" FIELD>
                            <div :class="`${arabic?'arFont':'enFont'} primary--text`">ACCOUNT API TOKEN</div>
                            <v-chip color="primary" :class="`${arabic?'arFont':'enFont'}`">{{user.account.token}}
                            </v-chip>
                            <v-btn v-clipboard:copy="user.account.token" v-clipboard:success="clipboardSuccessHandler"
                              v-clipboard:error="clipboardErrorHandler" color="success" x-small icon>
                              <v-icon size="10">content_copy</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col cols="6" FIELD>
                            <v-text-field :label="i18n['name']" v-model="user.account.name"
                              :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                          </v-col>
                          <v-col cols="6" FIELD>
                            <v-text-field :label="i18n['email']" v-model="user.account.email"
                              :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                          </v-col>
                          <v-col cols="6" FIELD class="text-right">
                            <v-switch :class="`${arabic?'arFont':'enFont'} text-right`"
                              :label="i18n['allow_platform_to_change_pricing_on_confirm']" v-model="user.account.allow_changes"
                              inset></v-switch>
                          </v-col>
                          <v-col cols="6" FIELD>
                            <v-switch :class="`${arabic?'arFont':'enFont'}`" :label="i18n['notifications_by_email']"
                              v-model="user.account.notification_emails" inset></v-switch>
                          </v-col>

                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" :class="`${arabic?'arFont':'enFont'}`"
                      @click="UpdateAccount(user.account)">{{ i18n["edit_information"] }}</v-btn>
                  </v-card-actions>
                </v-card>
                <v-card v-if="fifthPanel" fifthPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">money</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">{{ i18n["withdrawal_methods"] }}</div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">{{ i18n["withdrawal_methods_info"] }}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                  </v-card-text>
                  <v-card-actions v-if="disable_universal.error_message">
                    <v-spacer></v-spacer>
                    <div :class="`${arabic?'arFont':'enFont'} px-1`" style="font-size:11px;">
                      {{disable_universal.error_message}}</div>
                  </v-card-actions>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" :class="`${arabic?'arFont':'enFont'}`"
                      :disabled="disable_universal.disable" @click="()=>{dialog = true;newMethod={}}">{{ i18n["add_withdrawal_method"] }}</v-btn>

                    <v-btn v-if=" disable_universal.id_verification" color="secondary" @click="goTo('/account')"
                      :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n["click_here_to_verify_your_account"] }}</v-btn>

                    <v-dialog v-model="dialog" persistent max-width="800">
                      <v-card>
                        <v-card-title :class="`${arabic?'arFont':'enFont'}`" style="font-size:20px">{{ i18n['withdrawal_method'] }}
                        </v-card-title>
                        <v-card-text>
                          <v-row class="align-center">
                            <v-col cols="12" FIELD>
                              <v-autocomplete :items="paymentMethods" v-model="newMethod.type"
                                :label="i18n['withdrwal_method_tool']" autocomplete="disabled" outlined hide-details clearable
                                dense item-value="slug" :class="`${arabic?'arFont':'enFont'}`">
                                <template v-slot:selection="{ attr, on, item, selected }">
                                  <span v-bind="attr" :input-value="selected" v-on="on"
                                    :class="`${arabic?'arFont':'enFont'}`">
                                    <v-chip x-small>{{item[language]}}</v-chip>
                                  </span>
                                </template>
                                <template v-slot:item="{ item }">
                                  <span :class="`${arabic?'arFont':'enFont'}`">
                                    {{item[language]}}
                                  </span>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="6" FIELD>
                              <v-text-field :label="i18n['payment_method_name']" v-model="newMethod.name"
                                :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="ifPhoneNumber(newMethod.type)" FIELD>
                              <v-text-field :label="i18n['phone_number_for_account']" v-model="newMethod.phone_number"
                                :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'tiktok' || newMethod.type == 'snapchat' || newMethod.type == 'facebook'" FIELD>
                              <v-text-field :label="i18n['account_identifier']" v-model="newMethod.payment_account"
                                :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'usdt'" FIELD>
                                <v-text-field :label="i18n['usdt_trc20_address']" v-model="newMethod.payment_account"
                                  :class="`${arabic ? 'arFont' : 'enFont'}`" outlined hide-details dense></v-text-field>
                              </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'paypal' || newMethod.type == 'payoneer'" FIELD>
                              <v-text-field :label="i18n['paypal_email']" v-model="newMethod.paypal_email"
                                :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'bank'" FIELD>
                              <v-text-field :label="i18n['bank_name']" v-model="newMethod.bank"
                                :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'bank'" FIELD>
                              <v-text-field :label="i18n['bank_account_holder_name']" v-model="newMethod.bank_account_name"
                                :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'bank'" FIELD>
                              <v-text-field :label="i18n['account_number_iban']" v-model="newMethod.iban"
                                :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'bank'" FIELD>
                              <v-text-field :label="i18n['switft_code']" v-model="newMethod.swift"
                                :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="12" v-if="newMethod.type == 'bank'" :class="`${arabic?'arFont':'enFont'}`">
                              {{ i18n["special_for_us_bank_accounts"] }}
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'bank'" FIELD>
                              <v-text-field :label="i18n['account_number']" v-model="newMethod.account_number"
                                :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'bank'" FIELD>
                              <v-text-field label="Routing Number" v-model="newMethod.routing_number"
                                :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'bank'" FIELD>
                              <v-text-field label="FEDWIRE" v-model="newMethod.fedwire"
                                :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'bank'" FIELD>
                              <v-text-field :label="i18n['currency']" v-model="newMethod.currency"
                                :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'bank'" FIELD>
                              <v-text-field :label="i18n['bank_address']" v-model="newMethod.bank_address"
                                :class="`${arabic?'arFont':'enFont'}`" outlined hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'bank'" FIELD>
                              <v-text-field :label="i18n['detailed_address']" v-model="newMethod.user_address" :class="`${arabic?'arFont':'enFont'}`" outlined
                                hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'bank' || newMethod.type == 'cash_plus'" FIELD>
                              <v-text-field :label="i18n['city']" v-model="newMethod.city" :class="`${arabic?'arFont':'enFont'}`" outlined
                                hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'bank'" FIELD>
                              <v-text-field :label="i18n['country']" v-model="newMethod.country" :class="`${arabic?'arFont':'enFont'}`" outlined
                                hide-details dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-if="newMethod.type == 'cash_plus'" FIELD>
                              <v-text-field label="i18n['name_as_in_passport']" v-model="newMethod.official_name" :class="`${arabic?'arFont':'enFont'}`" outlined hide-details
                                dense></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions :class="`${arabic?'arFont':'enFont'}`">
                          <v-spacer></v-spacer>
                          {{  i18n['request_is_evaluated_in_24_hours'] }}
                          <v-btn color="primary" text @click.native="dialog = false"
                            :class="`${arabic?'arFont':'enFont'}`">{{ i18n['cancel'] }}</v-btn>
                          <v-btn color="primary" :disabled="!canSubmitForApproval" @click.native="submitPaymentMethod()"
                            :class="`${arabic?'arFont':'enFont'}`">{{ i18n['add']}}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-card-actions>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" v-for="(method, m) in user.account.methods" :key="'method-'+m"
                        class="elevation-2 py-0 my-1">
                        <v-row class="py-0">
                          <v-col cols="6" md="4" :class="`${arabic?'arFont':'enFont'}`">
                            {{method.name}}
                          </v-col>
                          <v-col cols="6" md="4" :class="`${arabic?'arFont':'enFont'}`">
                            <div :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;font-size:11px;">
                              {{  i18n["payment_method"] }}
                            </div>
                            <div v-if="paymentMethods.filter(x=>x.slug == method.type).length">
                              {{paymentMethods.filter(x=>x.slug == method.type)[0].text}}
                            </div>
                            <div v-if="ifPhoneNumber(method.type)">
                              {{method.phone_number}}
                            </div>
                            <div v-if="method.type == 'paypal' || method.type == 'payoneer'">
                              {{method.paypal_email}}
                            </div>
                            <div v-if="method.type == 'usdt'">
                              {{ method.payment_account }}
                            </div>
                            <div v-if="method.type == 'bank'">
                              <div>{{method.bank}}</div>
                              <div>{{method.bank_account_name}}</div>
                              <div>{{method.iban}}</div>
                              <div>{{method.swift}}</div>
                              <div>{{method.account_number}}</div>
                              <div>{{method.routing_number}}</div>
                              <div>{{method.fedwire}}</div>
                            </div>
                          </v-col>
                          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'}`">
                            <div :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;font-size:11px;">{{ i18n["review_is_done"] }}</div>
                            <div v-if="method.reviewed">
                              <v-icon color="success">done</v-icon>
                            </div>
                            <div v-else>
                              <v-icon color="error">close</v-icon>
                            </div>
                          </v-col>
                          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'}`">
                            <div :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;font-size:11px;">{{ i18n["approved"] }}</div>
                            <div v-if="method.approved">
                              <v-icon color="success">done</v-icon>
                            </div>
                            <div v-else>
                              <v-icon color="error">close</v-icon>
                              <span v-if="method.reviewed" :class="`${arabic?'arFont':'enFont'}`">{{ i18n['rejected'] }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" md="12" class="py-1" :class="`${arabic?'arFont':'enFont'}`"
                            v-if="method.note">
                            <v-divider></v-divider>
                            <div>{{ i18n['note'] }}</div>
                            <div>{{method.note}}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-card v-if="sixthPanel" sixthPanel :loading="loading">
                  <VerificationID @reloadSubs="loadSubmissions" @snackbarNotification="sendSnackbarNotification"
                    :data="id_submissions" />
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Verification from '@/components/Verification'
  import VerificationEmail from '@/components/VerificationEmail'
  import VerificationID from '@/components/VerificationID';
  import axios from 'axios';
  const headers = {
    'Accept': 'application/json'
  };
  const fireapi = 'https://us-central1-shark-sellers.cloudfunctions.net/main';

  export default {
    components: {
      Verification,
      VerificationEmail,
      VerificationID
    },
    data() {
      return {
        loading: false,
        dialog: false,
        vresource: [],
        resource: [],
        search: null,
        rules: {
          required: value => !!value || this.i18n['required'],
          email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
        },
        resourceKeys: [

        ],
        resourceSettings: {
          resourceName: null,
          search: false,
          create: false,
          pagination: true,
        },
        newResource: {},
        editing: false,
        deleting: false,
        firstPanel: true,
        secondPanel: false,
        thirdPanel: false,
        fourthPanel: false,
        fifthPanel: false,
        sixthPanel: false,
        selectedPanel: 'firstPanel',
        subitems: [{
            text: 'personal_information',
            icon: 'person',
            value: 'firstPanel'
          },
          {
            text: 'change_password',
            icon: 'password',
            value: 'secondPanel'
          },
          {
            text: 'affiliates',
            icon: 'loyalty',
            value: 'thirdPanel'
          },
          {
            text: 'business_account',
            icon: 'store',
            value: 'fourthPanel'
          },
          {
            text: 'payment_methods',
            icon: 'money',
            value: 'fifthPanel'
          },
          {
            text: 'identity_verification',
            icon: 'face',
            value: 'sixthPanel'
          }
        ],
        account: {},
        newMethod: {},
        payment_methods: [],
        id_submissions: [],
        sub_info: {}
      }
    },
    methods: {
      async sendSnackbarNotification(msg, type) {
        this.$emit('snackbarNotification', msg, type)
      },
      ifPhoneNumber(method) {
        if (this.$store.state.paymentMethods.filter(x => x.number).map(x => x.slug).includes(method)) {
          return true
        } else {
          return false
        }
      },
      clipboardSuccessHandler() {
        this.$emit('snackbarNotification', `Copied`, 'success')
      },
      clipboardErrorHandler() {
        this.$emit('snackbarNotification', `Failed`, 'error')
      },
      async loadPaymentMethod() {
        return new Promise(async (res, rej) => {
          this.payment_methods = await this.$store.dispatch('getResource', {
            resource: `/payment-methods`
          })
          console.log(this.payment_methods)
          res(true)
        })
      },
      async submitPaymentMethod() {
        return new Promise(async (res, rej) => {
          let r = this.newMethod
          this.loading = true
          if (r.payment_method == 'paypal' || r.payment_method == 'payoneer') {
            if (!r.paypal_email) {
              this.$emit('snackbarNotification', this.i18n['paypal_email_is_required'], 'error')
              this.loading = false
              return
            }
          } else if (r.payment_method == 'zain_cash') {
            if (!r.phone_number) {
              this.$emit('snackbarNotification', this.i18n['phone_number_is_required'], 'error')
              this.loading = false
              return
            }
          } else if (r.payment_method == 'vodafone_cash') {
            if (!r.phone_number) {
              this.$emit('snackbarNotification', this.i18n['phone_number_is_required'], 'error')
              this.loading = false
              return
            }
          } else if (r.payment_method == 'bank') {
            if (!r.bank || !r.bank_account_name || !r.iban || !r.swift) {
              this.$emit('snackbarNotification', this.i18n["all_bank_account_fields_required"], 'error')
              this.loading = false
              return
            }
          }

          let sub = await this.$store.dispatch('postResource', {
            resource: `/payment-methods`,
            value: r
          })
          await this.$store.dispatch('getUser')
          this.$emit('snackbarNotification', this.i18n["payment_method_submitted_for_approval"], 'success')
          this.loading = false
          this.dialog = false
          res(true)
        })
      },
      async resetPass() {
        this.loading = true
        // // console.log(this.user)
        let r = await axios.post(`${fireapi}/resetPassword`, this.user, {
          headers
        }).then(x => x.data)
        // console.log(r)
        this.loading = false
      },
      async updateResource(r) {
        return new Promise(async (res, rej) => {
          this.loading = true
          // console.log(r)
          await this.$store.dispatch('putResource', {
            resource: this.$route.path + `/${r.id}`,
            value: r
          })
          this.loadResource()
          this.loading = false
        })
      },
      async UpdateMe(r) {
        this.loading = true
        // console.log(r)
        await this.$store.dispatch('putResource', {
          resource: '/users/updateme' + `/${r.id}`,
          value: r
        })
        this.$emit('snackbarNotification', this.i18n['update_success'], 'success')
        this.loading = false
      },
      async UpdateAccount(r) {
        this.loading = true
        // console.log(r)
        delete r.leads

        await this.$store.dispatch('putResource', {
          resource: '/accounts' + `/${r.id}`,
          value: r
        })
        await this.$store.dispatch('getUser')
        this.$emit('snackbarNotification', this.i18n['update_success'], 'success')
        this.loading = false
      },
      showPannel(v) {
        this[v] = true
        let all = this.subitems.map(x => x.value)
        all.filter(x => x != v).forEach(x => this[x] = false)
      },
      setResourceName() {
        this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
      },
      async getCounters() {
        this.loading = true
        this.counters = await this.$store.dispatch('getResource', {
          resource: `/leads-counter`
        })
        // console.log(this.counters)
        this.loading = false
      },
      async loadSubmissions() {

        return new Promise(async (res, rej) => {
          this.loading = true
          let r_subs = await this.$store.dispatch(`getResource`, {
            resource: `/id-verification`
          })
          this.id_submissions = r_subs.data
          console.log(this.id_submissions);
          this.loading = false
          res(r_subs)
        })
      }




    },
    computed: {
      canSubmitForApproval() {
        if (this.newMethod.type == 'cash') {
          return true
        } else if (this.newMethod.type == 'zain_cash') {
          if (this.newMethod.phone_number) {
            return true
          } else {
            return false
          }
        } else if (this.newMethod.type == 'vodafon_cash') {
          if (this.newMethod.phone_number) {
            return true
          } else {
            return false
          }
        } else if (this.newMethod.type == 'jawwalpay') {
          if (this.newMethod.phone_number) {
            return true
          } else {
            return false
          }
        } else if (this.newMethod.type == 'dinarak') {
          if (this.newMethod.phone_number) {
            return true
          } else {
            return false
          }
        } else if (this.newMethod.type == 'orange') {
          if (this.newMethod.phone_number) {
            return true
          } else {
            return false
          }
        } else if (this.newMethod.type == 'umaniah') {
          if (this.newMethod.phone_number) {
            return true
          } else {
            return false
          }
        } else if (this.newMethod.type == 'paypal' || this.newMethod.type == 'payoneer') {
          if (this.newMethod.paypal_email) {
            return true
          } else {
            return false
          }
        } else if (this.newMethod.type == 'usdt') {
        if (this.newMethod.payment_account) {
          return true
        } else {
          return false
        }
      } else if (this.newMethod.type == 'bank') {
          let check = this.newMethod.bank &&
            this.newMethod.bank_account_name &&
            this.newMethod.iban &&
            this.newMethod.user_address &&
            this.newMethod.city &&
            this.newMethod.city &&
            this.newMethod.swift ? true : false
          if (check) {
            return true
          } else {
            return false
          }
        } else if (this.newMethod.type == 'snapchat') {
          if (this.newMethod.payment_account) {
            return true
          } else {
            return false
          }
        } else if (this.newMethod.type == 'cash_plus') {
          if (this.newMethod.official_name && this.newMethod.city) {
            return true
          } else {
            return false
          }
        } else if (this.newMethod.type == 'tiktok') {
          if (this.newMethod.payment_account) {
            return true
          } else {
            return false
          }
        } else if (this.newMethod.type == 'facebook') {
          if (this.newMethod.payment_account) {
            return true
          } else {
            return false
          }
        } else if (this.newMethod.type == 'stock_purchase') {
          return true

        }
      },
      api() {
        return this.$store.state.settings.apiBase
      },
      users() {
        let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
        // console.log(sa)
        return this.$store.state.users.filter(x => {
          if (!sa) {
            return x.superior == this.$store.state.user.level
          } else return x
        })
      },
      site() {
        return this.$store.state.site
      },
      items() {
        return this.$store.state.menu
      },
      superAdmin() {
        return this.$store.state.superAdmin
      },
      isLogin() {
        return this.$store.state.centralLogin
      },
      language() {
        return this.$store.state.language
      },
      globalLoading() {
        return this.$store.state.globalLoading
      },
      user() {
        return this.$store.state.user
      },
      i18n() {
        return this.$store.state.i18n[this.$store.state.language]
      },
      arabic() {
        if (this.$store.state.language == 'ar') return true
      },
      routeTitle() {
        let main = this.$store.state.menu.filter(x => x.path == this.$route.path)
        let sub = [].concat(...this.$store.state.menu.map(x => x.subs)).filter(x => x).filter(x => x.path == this.$route
          .path)
        if (main.length) {
          return this.$store.state.i18n[this.$store.state.language][main[0].text]
        } else if (sub.length) {
          return this.$store.state.i18n[this.$store.state.language][sub[0].text]
        } else {
          return ''
        }
      },
      roles() {
        return this.$store.state.userRoles
      },
      notifications() {
        return this.$store.state.notifications.sort((a, b) => b.timestamp - a.timestamp)
      },
      paymentMethods() {
        return this.$store.state.paymentMethods.filter(x => x.active)
      },

      disable_universal() {

        if (!this.id_submissions.length) {
          return {
            disable: true,
            id_verification: true,
            error_message: this.i18n["please_verify_your_account_to_add_a_payment_method"],
          };
        } else if (
          this.id_submissions.length &&
          !this.id_submissions.filter((x) => x.reviewed).length
        ) {
          return {
            disable: true,
            error_message: this.i18n["you_have_a_pending_verification_request"],
          };
        } else if (
          this.id_submissions.length &&
          !this.id_submissions.filter((x) => x.approved).length
        ) {
          return {
            disable: true,
            id_verification: true,
            error_message: this.i18n["you_have_no_approved_identity_verification_request"],
          };
        } else {
          return false
        };
      }
    },
    async created() {
      await this.loadSubmissions()
      this.setResourceName()
      this.loadPaymentMethod()

    },
  }
</script>

<style>

</style>